/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.8.3",
  "gitBuildTime": "2026-10-22T22:05:15.921Z",
  "gitBuildVersion": "2.8.3",
  "gitCommitId": "c08476e",
  "gitCommitIdFull": "c08476ef7144ed5a3c4ce65ddb907ba7038b30ed",
  "gitCommitTime": "2026-10-22T22:03:44.000Z",
  "version": "2.8.3-2026-10-22T22:03:44.000Z-(c08476e)"
};
